import React from 'react'
import Title from '../../../../components/typography/title.component'
import Container from '../../../../components/layout/container.component'
import SearchForm from './components/search-form.component'
import FontAwesome from 'react-fontawesome'
import ModalConfirmation from '../../../../components/modal/modal-confirmation.component'
import AccordionSecondary from '../../../../components/accordion/accordion-secondary.component'
import PaginationComponent from '../../../../components/pagination/pagination.component'
import { PRIMARY_COLOR } from '../../../../styles/colors.style'
import { routes } from '../../../../constants/routes.constants'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { AdminService } from '../../../../services/admin.service'
import { toastActions } from '../../../../actions/toast.actions'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../../../ducks/site/site'

class UserSearchComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			name: '',
			active: '',
			modalTitle: '',
			modalMessage: '',
			modalIsOpen: false,
		}
		this.id = null
		this.active = null
	}

	render() {
		const { name, active, modalTitle, modalMessage, modalIsOpen } = this.state
		return (
			<Container>
				<Title>Funcionários</Title>
				<AccordionSecondary
					arrow={false}
					multiple={false}
					noClickable
					noAnimated
					items={getAccordionItems.call(this)}
				/>
				<div data-permission="CB0FB1A9065FAE57A333F7C0597D74EB162060D4">
					<PaginationComponent
						ref={'pagination'}
						getData={AdminService.searchUsers}
						headers={paginationHeaders}
						params={{ name, active }}
						rowsPerPage={50}
						renderRow={paginationRenderRow.bind(this)}
						sortable={paginationSortable}
					/>
				</div>
				<ModalConfirmation
					isOpen={modalIsOpen}
					title={modalTitle}
					onResult={onResult.bind(this)}>
					{modalMessage}?
				</ModalConfirmation>
			</Container>
		)
	}
}

const paginationHeaders = [
	{ header: 'Nome', key: 'name' },
	{ header: 'E-mail', key: 'email' },
	{ header: 'Situação', key: 'identityUserId', align: 'center' },
]

const paginationSortable = {
	defaultOrder: 'asc',
	cols: [{ key: 'name' }],
}

function paginationRenderRow(rowData, headers) {
	return headers.map(({ key }) => {
		const cellData = rowData[key]
		const active = rowData['active']
		if (key === 'identityUserId') {
			return (
				<td key={key} align="center">
					<FontAwesome
						style={active ? { color: PRIMARY_COLOR } : {}}
						name={active ? 'toggle-on' : 'toggle-off'}
						size="lg"
						title={active ? 'Usuário ativo' : 'Usuário inativo'}
						onClick={(e) => {
							e.stopPropagation()
							this.id = cellData
							this.active = active
							this.setState({
								modalTitle: `${active ? 'Inativar' : 'Ativar'} usuário`,
								modalMessage: `Confirma a ${
									active ? 'inativação' : 'ativação'
								} do usuário ${rowData['name']}`,
								modalIsOpen: true,
							})
						}}
					/>
				</td>
			)
		} else {
			return (
				<td
					key={key}
					onClick={manageUser.bind(this, rowData['identityUserId'])}>
					<span title={cellData}>{cellData}</span>
				</td>
			)
		}
	})
}

function manageUser(id) {
	this.props.history.push(`${routes.ADMIN}/funcionario/${id}`)
}

function onResult(confirmed) {
	this.setState({ modalIsOpen: false })
	if (!confirmed) return
	const { showLoading, hideLoading, success, danger } = this.props
	showLoading()
	if (this.active) {
		AdminService.inactivateUser({ userId: this.id })
			.then((response) => {
				hideLoading()
				if (response.success) {
					success({ message: 'Usuário inativado com sucesso' })
					this.refs.pagination.reload()
				} else
					danger({
						message: response.errors[0],
					})
			})
			.catch(() => {
				hideLoading()
				danger({
					message:
						'Não foi possível inativar o usuário, por favor tente novamente mais tarde',
				})
			})
	} else {
		AdminService.activateUser({ userId: this.id })
			.then((response) => {
				hideLoading()
				if (response.success) {
					success({ message: 'Usuário ativado com sucesso' })
					this.refs.pagination.reload()
				} else
					danger({
						message: response.errors[0],
					})
			})
			.catch(() => {
				hideLoading()
				danger({
					message:
						'Não foi possível ativar o usuário, por favor tente novamente mais tarde',
				})
			})
	}
}

function getAccordionItems() {
	return [
		{
			title: 'Filtros',
			content: (
				<SearchForm
					ref={'form'}
					onSubmit={handleSubmit.bind(this)}
					{...this.props}
				/>
			),
		},
	]
}

function handleSubmit({ name, status }) {
	this.setState(
		{
			name,
			active: status === 'none' ? '' : status,
		},
		() => this.refs.pagination.reload()
	)
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			...SiteCreators,
			...toastActions,
		},
		dispatch
	)

const connectedUserSearchComponent = withRouter(
	connect(null, mapDispatchToProps)(UserSearchComponent)
)
export { connectedUserSearchComponent as ModuleRootComponent }
